import { render, staticRenderFns } from "./caseInfo.vue?vue&type=template&id=1024c992&scoped=true"
import script from "./caseInfo.vue?vue&type=script&lang=js"
export * from "./caseInfo.vue?vue&type=script&lang=js"
import style0 from "./caseInfo.vue?vue&type=style&index=0&id=1024c992&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1024c992",
  null
  
)

export default component.exports